import React, { useEffect, useState } from "react";
import RecommendationNoteView from "../../common/components/RecommendationNoteView";
import { ImageBand } from "../../common/components/ImageComponents/ImageBand";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import Portal from "../../common/components/Portal";
import { DynamicField, Field, renderHighlightedLabel } from "../../recommendations/components/InfoPages/Band";
import ReactTooltip from "react-tooltip";
import { CkeditorConfiguration } from "../../smartCharts/CkEditorConfig";
import assetSurveyActions from "../../assetSurveyProject/actions";
import { checkPermission } from "../../../config/utils";
import { sanitizeHtml } from "../../common/components/SafeHtml";

const MobileRecommendationDetail = ({
    MobileExtraBands,
    isCR,
    isMR,
    basicDetails,
    imageResponse,
    invalidFields,
    deleteImage,
    handleBandClick,
    setToolTip,
    onCancelNote,
    showNoteModal,
    mobileExtraBandValues,
    updateImage,
    refreshImageList,
    openReportNote,
    editorHeight,
    editorConfiguration,
    isMob = false,
    showType = "",
    showFields = [],
    isRestore = false,
    isInitialSyncedDatamodal = false,
    keys = "",
    fieldSearch = "",
    isSyncedRestoreModal = false,
    isCurrentValue = false
}) => {
    const [activeNarrativeTab, setActiveNarrativeTab] = useState("mobile_narrative");
    const searchText = (fieldSearch ?? "").toLowerCase().trim();

    const matchesSearch = text => !searchText || (text ?? "").toLowerCase().includes(searchText);
    const visibleBands =
        MobileExtraBands && typeof MobileExtraBands === "object"
            ? Object.entries(MobileExtraBands).filter(([band]) => {
                  const isAsset = band?.toLowerCase()?.includes("asset");
                  const recomType = mobileExtraBandValues?.recommendation_type?.value?.toLowerCase();
                  const hasMatchingField = (MobileExtraBands?.[band] ?? []).some(field => {
                      const fieldKey = field?.field_name;
                      if (
                          recomType === "asset" &&
                          ["asset_condition_id", "installed_year", "service_life", "usefull_life_remaining", "crv"].includes(fieldKey)
                      )
                          return false;
                      const label = (field?.label ?? "").toLowerCase();
                      const labelMatch = matchesSearch(label);
                      return showType ? labelMatch && showFields?.includes(fieldKey) : labelMatch;
                  });
                  return recomType === "asset" ? hasMatchingField : !isAsset && hasMatchingField;
              })
            : [];
    return (
        <div className={`col-md-12 detail-recom ${!isSyncedRestoreModal ? "scorll-flow" : "p-0 pb-2"} mob-recom-main`}>
            <ReactTooltip
                id="recommendation_details"
                effect="solid"
                place="left"
                backgroundColor="#007bff"
                className="rc-tooltip-custom-class"
                html={true}
                getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                delayShow={500}
            />
            <div class="outer-rcm recommendations">
                <div class="cnt-sec">
                    <div class="row">
                        <div class={`${isRestore ? "col-md-12" : "col-md-8"} col-md-align`}>
                            <div id="accordion">
                                {(visibleBands ?? [])?.length === 0 ? (
                                    <div className="col-md-12 text-center p-4">
                                        <p className="no-data-text">No Data</p>
                                    </div>
                                ) : (
                                    (visibleBands ?? [])?.map(([band, fields]) => {
                                        const hiddenFieldsForAsset = [
                                            "asset_condition_id",
                                            "installed_year",
                                            "service_life",
                                            "usefull_life_remaining",
                                            "crv"
                                        ];

                                        const recommendationType = mobileExtraBandValues?.recommendation_type?.value?.toLowerCase();
                                        const filteredFields = (fields || [])
                                            .filter(f => {
                                                const fieldName = f?.field_name?.toLowerCase?.() ?? "";
                                                const label = (f?.label ?? "").toLowerCase();
                                                const fieldKey = f?.field_name;
                                                const matchesFieldSearch = showType
                                                    ? matchesSearch(label) && showFields.includes(fieldKey)
                                                    : matchesSearch(label);

                                                const notHidden =
                                                    fieldName !== "mobile_recomm_notes_temp" &&
                                                    fieldName !== "recommendation_type" &&
                                                    !(recommendationType === "asset" && hiddenFieldsForAsset.includes(f.field_name));

                                                return notHidden && matchesFieldSearch;
                                            })
                                            .map(f => {
                                                if (f.field_name?.toLowerCase() === "description") {
                                                    return {
                                                        ...f,
                                                        rules: {
                                                            ...f.rules,
                                                            column_span: 4
                                                        }
                                                    };
                                                }
                                                return f;
                                            });
                                        const beforeDynamicFields =
                                            band?.toLowerCase() === "priority" && !showType && matchesSearch("priority total") ? (
                                                <div className="txt-rcm col-md-3">
                                                    <div className="content-inp-card blue-sec">
                                                        <h3 className="p-name">{renderHighlightedLabel("Priority Total", fieldSearch)}</h3>
                                                        <h3 className="color-white">
                                                            {filteredFields?.find(e => e?.field_name === "priority")?.value || 0}
                                                        </h3>
                                                    </div>
                                                </div>
                                            ) : null;


                                        return (
                                            <MobileRecomBand
                                                key={band}
                                                bandName={band}
                                                bandId={isRestore ? `${keys}-${band?.split(" ")?.join("_")}` : band?.split(" ")?.join("_")}
                                                setToolTip={setToolTip}
                                                data={mobileExtraBandValues}
                                                fields={filteredFields ?? []}
                                                handleBandClick={handleBandClick}
                                                isDynamic
                                                invalidFields={invalidFields ?? {}}
                                                isBandOpen={band === "Geo Hierarchy" || band === "Recommendations"}
                                                isMobRecom={isMob}
                                                dynamicClassName="dynamic-trim-txt trim-txt"
                                                hasTooltip={true}
                                                beforeDynamicFields={beforeDynamicFields}
                                                isCurrentValue={isCurrentValue}
                                                isSyncedRestoreModal={isSyncedRestoreModal ?? false}
                                                fieldSearch={fieldSearch}
                                            />
                                        );
                                    })
                                )}
                            </div>
                        </div>
                        {!isRestore && (
                            <div class="col-md-4 back-set">
                                <div className="details-img-block details-img-new" style={{ height: "250px" }}>
                                    <ImageBand
                                        basicDetails={basicDetails}
                                        updateImage={updateImage}
                                        deleteImage={deleteImage}
                                        getAllImagesResponse={imageResponse}
                                        refreshImageList={refreshImageList}
                                        isSurveyAssetView={isMR}
                                        isAnalyseViewModal={true}
                                        isMobRecom={true}
                                        hasEdit={checkPermission("forms", "mobile_recommendations", "edit")}
                                    />
                                </div>
                                {showNoteModal && (
                                    <Portal
                                        body={
                                            <RecommendationNoteView
                                                notes={
                                                    activeNarrativeTab === "ai_narrative"
                                                        ? (basicDetails?.aiNarrative ?? "")
                                                        : activeNarrativeTab === "ai_recom"
                                                          ? (basicDetails?.aiRecom ?? "")
                                                          : (basicDetails?.note_html ?? "")
                                                }
                                                onCancel={onCancelNote}
                                                isRecommendationView={true}
                                                isCR={isCR}
                                                heading={
                                                    activeNarrativeTab === "mobile_narrative"
                                                        ? "Voice Notes"
                                                        : activeNarrativeTab === "ai_recom"
                                                          ? "AI Recommendation"
                                                          : "AI Recommendation Narrative"
                                                }
                                            />
                                        }
                                        onCancel={onCancelNote}
                                    />
                                )}
                                <div class="template">
                                    <div class="heading mob-narrative-template">
                                        <div className="tabs new-ui-tab">
                                            <button
                                                type="button"
                                                className={`tab-button ${activeNarrativeTab === "mobile_narrative" ? "active" : ""}`}
                                                data-tip={`Voice Note`}
                                                data-for="recommendation_details"
                                                onClick={() => setActiveNarrativeTab("mobile_narrative")}
                                            >
                                                Voice Notes
                                            </button>
                                            <button
                                                type="button"
                                                className={`tab-button ${activeNarrativeTab === "ai_narrative" ? "active" : ""}`}
                                                data-tip={`AI Recommendation Narrative`}
                                                data-for="recommendation_details"
                                                onClick={() => setActiveNarrativeTab("ai_narrative")}
                                            >
                                                AI Rec. Narrative
                                            </button>
                                            <button
                                                type="button"
                                                className={`tab-button ${activeNarrativeTab === "ai_recom" ? "active" : ""}`}
                                                data-tip={`AI Recommendation`}
                                                data-for="recommendation_details"
                                                onClick={() => setActiveNarrativeTab("ai_recom")}
                                            >
                                                AI Rec.
                                            </button>
                                        </div>
                                        <img
                                            data-tip={`Click to Expand`}
                                            data-for="recommendation_details"
                                            data-class="rc-tooltip-custom-class"
                                            data-place="left"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => openReportNote()}
                                            src="/img/expand1.svg"
                                            alt=""
                                        />
                                    </div>
                                    <div
                                        class="cnt-temp-area notes-outer-area content-break overflow-ht-outer notranslate mob-normal-recom"
                                        style={{ maxHeight: `${editorHeight}px`, minHeight: "200px" }}
                                    >
                                        <CKEditor
                                            id="read-only-text-forms"
                                            editor={Editor}
                                            config={{ ...CkeditorConfiguration, toolbar: [] }}
                                            data={
                                                activeNarrativeTab === "ai_narrative"
                                                    ? (basicDetails?.aiNarrative ?? "")
                                                    : activeNarrativeTab === "ai_recom"
                                                      ? (basicDetails?.aiRecom ?? "")
                                                      : (basicDetails?.note_html ?? "")
                                            }
                                            onReady={editor => {
                                                editor?.setData(
                                                    activeNarrativeTab === "ai_narrative"
                                                        ? (basicDetails?.aiNarrative ?? "")
                                                        : activeNarrativeTab === "ai_recom"
                                                          ? (basicDetails?.aiRecom ?? "")
                                                          : (basicDetails?.note_html ?? "")
                                                );
                                                editor?.enableReadOnlyMode("my-feature-id");
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
export const MobileRecomBand = ({
    bandName = "",
    data = {},
    setToolTip,
    fields = [],
    bandId = "",
    handleBandClick,
    isDynamic,
    isBandOpen = false,
    invalidFields = {},
    hasTooltip = false,
    dynamicClassName = "",
    extraFields = null,
    beforeDynamicFields = null,
    isCurrentValue = false,
    isSyncedRestoreModal = false,
    fieldSearch = ""
}) => {
    let usedHeader = 0;
    const headerElems = [];
    let skipHeader = false;
    for (const elem of fields) {
        const origSpan = Number(elem.rules?.column_span) || 1;
        if (origSpan > 3) {
            // skipHeader = true;
            usedHeader = 3;
            break;
        }
        const span = Math.min(origSpan, 3);
        if (usedHeader + span <= 3) {
            usedHeader += span;
            headerElems.push(elem);
        } else {
            break;
        }
    }
    const remainingHeaderCells = 3 - usedHeader;

    const bodyCandidates = fields.filter(elem => !headerElems.includes(elem));
    const bodyRows = [];
    let currentRow = [];
    let currentSpan = 0;

    bodyCandidates.forEach(elem => {
        const span = Math.min(Number(elem.rules?.column_span) || 1, 4);
        if (currentSpan + span > 4) {
            bodyRows.push(currentRow);
            currentRow = [];
            currentSpan = 0;
        }
        currentRow.push({ elem, span });
        currentSpan += span;
    });
    if (currentRow.length) bodyRows.push(currentRow);
    return (
        <div className="card">
            <div className="card-header" id={`heading-${bandId}`}>
                <div className="otr-recom-div">
                    <button
                        className="btn btn-link"
                        data-toggle="collapse"
                        onClick={handleBandClick}
                        data-target={`#${bandId}`}
                        aria-expanded={isBandOpen ? "true" : "false"}
                    >
                        {bandName}
                    </button>
                    {beforeDynamicFields && beforeDynamicFields}
                    {!skipHeader &&
                        (headerElems || [])
                            ?.filter(e => e?.field_name !== "priority")
                            ?.map(elem => {
                                const span = Math.min(Number(elem.rules?.column_span) || 1, 3);
                                const colSize = span * 3;
                                const booleanValue =
                                    elem?.field_type === "boolean" ? (elem?.value === true ? "Yes" : elem?.value === false ? "No" : "") : "";
                                return (
                                    <div key={elem.field_name} className={`col-md-${colSize} basic-box`}>
                                        {isDynamic ? (
                                            <DynamicField
                                                elem={elem}
                                                data={data}
                                                invalidFields={invalidFields}
                                                hasTooltip={hasTooltip && elem?.field_name?.toLowerCase() !== "description"}
                                                dynamicClassName={span > 1 ? `${dynamicClassName} mob-recom-wide-value` : dynamicClassName}
                                                flat_value={booleanValue}
                                                isMR
                                                isCurrentValue={isCurrentValue}
                                                isSyncedRestoreModal={isSyncedRestoreModal}
                                                fieldSearch={fieldSearch}
                                            />
                                        ) : (
                                            <Field
                                                elem={elem}
                                                data={data}
                                                isCurrentValue={isCurrentValue}
                                                isSyncedRestoreModal={isSyncedRestoreModal}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                    {[...Array(remainingHeaderCells)].map((_, i) => (
                        <div key={`filler-${i}`} className="col-md-3 basic-box" />
                    ))}
                </div>
            </div>

            <div id={bandId} className={isBandOpen ? "collapse show" : "collapse"} aria-labelledby={`heading-${bandId}`}>
                <div className="card-body">
                    <div className="outer-rcm mt-1 basic-dtl-otr p-0 d-flex flex-wrap">
                        {bodyRows.map((row, rowIdx) => (
                            <React.Fragment key={rowIdx}>
                                {row.map(({ elem, span }) => {
                                    const booleanValue =
                                        elem?.field_type === "boolean" ? (elem?.value === true ? "Yes" : elem?.value === false ? "No" : "") : "";
                                    return (
                                        <div key={elem.field_name} className={`col-md-${span * 3} basic-box`}>
                                            {isDynamic ? (
                                                <DynamicField
                                                    elem={elem}
                                                    data={data}
                                                    invalidFields={invalidFields}
                                                    hasTooltip={hasTooltip && elem?.field_name?.toLowerCase() !== "description"}
                                                    dynamicClassName={span > 1 ? `${dynamicClassName} mob-recom-wide-value` : dynamicClassName}
                                                    flat_value={booleanValue}
                                                    isMR
                                                    isCurrentValue={isCurrentValue}
                                                    isSyncedRestoreModal={isSyncedRestoreModal}
                                                    fieldSearch={fieldSearch}
                                                />
                                            ) : (
                                                <Field
                                                    elem={elem}
                                                    data={data}
                                                    isCurrentValue={isCurrentValue}
                                                    isSyncedRestoreModal={isSyncedRestoreModal}
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                                {(() => {
                                    const used = row.reduce((sum, r) => sum + r.span, 0);
                                    const cols = (4 - used) * 3;
                                    return cols > 0 ? <div className={`col-md-${cols} basic-box`} /> : null;
                                })()}
                            </React.Fragment>
                        ))}
                        {extraFields ? extraFields : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileRecommendationDetail;
